import { createSlice } from "@reduxjs/toolkit";

export const dashboardPreschedule = createSlice({
  name: "dashboard-preschedule",
  initialState: {
    value: { allPrescheduleEquip: [],preschedule: {}, isFinished: false },
  },
  reducers: {
    setAllPrescheduleDevolutionEquipment(state, { payload }) {
      state.value.allPrescheduleEquip = payload ;
    },
    setPrescheduledevolutionEquipment(state, { payload }) {
      state.value.preschedule = payload;
    },
    setIsFinished(state, { payload }) {
      state.value.isFinished = payload;
    },
  },
});

export const {setAllPrescheduleDevolutionEquipment, setPrescheduledevolutionEquipment, setIsFinished } =
  dashboardPreschedule.actions;
export default dashboardPreschedule.reducer;
